import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { history } from '../../state/store';

import Button from '../form/Button';
import Message from '../form/Message';
import UserApi from '../../api/user';

import GroupApi from '../../api/group';
import AuthService from '../../state/auth.service';
import AuthUtils from '../../AuthUtils';
import DynamicMultiSelect from '../../components/common/DynamicMultiSelect/DynamicMultiSelect';

class NewTeamMemberPage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            name: '',
            email: '',
            message: '',
            isLoading: true,
            permissions: 'Administrator',
            organizations: [],
            selectedOrganizations: [],
            edit: props.userId,
        };

        if (this.state.edit) {
            this.loadUser(this.state.edit);
        }

        this.onChangeName = this.onChangeName.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.goBack = this.goBack.bind(this);
    }
    componentDidMount() {
        this.getLists();
    }

    onChangeName(e) {
        if (this.state.edit) return;
        this.setState({
            name: e.target.value,
        });
    }

    onChangeEmail(e) {
        if (this.state.edit) return;
        this.setState({
            email: e.target.value,
        });
    }

    goBack() {
        history.goBack();
    }

    loadUser = async email => {
        const userInfo = await UserApi.getConsultantByEmail(email);
        const keys = [];
        if (_.has(userInfo, 'resourceFiltered.organizations') && userInfo.resourceFiltered.organizations !== null) {
            Object.keys(userInfo.resourceFiltered.organizations).map(function(item) {
                keys.push(parseInt(item, 10));
                return false;
            });
        }
        let role = userInfo.role;

        userInfo.resource = AuthUtils.serializeResourceObject(userInfo.resource);
        if ((userInfo.resource && userInfo.resource.startsWith && userInfo.resource.startsWith('@') && !userInfo.resource.endsWith('v'))) {
            role = 'Restricted';
        } 
        this.setState({
            name: userInfo.name,
            email: userInfo.email,
            permissions: role,
            selectedOrganizations: keys,
        });
    };

    onFormSubmit(event) {
        event.preventDefault();

        let permissions = this.state.permissions;
        if (permissions === 'Restricted') {
            permissions = 'Administrator';
        }

        let orgs = {};
        if (this.state.permissions === 'Administrator') {
            orgs = '-1';
        } else {
            this.state.selectedOrganizations.forEach(org => {
                _.set(orgs, `${org}`, permissions);
            });
        }

        UserApi.invite(this.state.email, this.state.name, this.state.permissions === 'Administrator' ? '*' : '@', this.state.permissions, orgs);
        if (this.state.edit) {
            this.setState({
                message: `Updated user ${this.state.name} with email: ${this.state.email}`,
            });
        } else {
            this.setState({
                message: `Invited user ${this.state.name} at email: ${this.state.email}`,
            });
        }
    }
    sleep = ms => {
        return new Promise(resolve => {
            setTimeout(resolve, ms);
        });
    };
    getLists = async () => {
        let groupId = await AuthService.getUser();
        if (!_.has(groupId, 'group_id')) {
            return;
        }
        groupId = groupId.group_id;

        this.setState({ isLoading: true }, () => {
            GroupApi.listOrganizationMetrics(groupId)
                .then(async orgs => {
                    this.setState({
                        organizations: orgs,
                        isLoading: false,
                    });
                })
                .catch(err => {
                    this.setState({
                        isLoading: false,
                    });
                });
        });
    };

    checkItem = key => {
        let { selectedOrganizations } = this.state;
        if (_.indexOf(selectedOrganizations, key) >= 0) {
            _.pullAt(selectedOrganizations, [_.indexOf(selectedOrganizations, key)]);
        } else {
            selectedOrganizations.push(key);
        }
        this.setState({ selectedOrganizations: selectedOrganizations });
    };

    checkAll = toggle => {
        const selectedOrganizations = [];
        if (toggle) {
            for (let i = 0; i < this.state.organizations.length; i++) {
                selectedOrganizations.push(this.state.organizations[i].id);
            }
        }
        this.setState({ selectedOrganizations: selectedOrganizations });
    };

    changePermissions = event => {
        this.setState({ permissions: event.target.value });
    };

    render() {
        const { isLoading, organizations, selectedOrganizations, edit } = this.state;
        if (isLoading) {
            return (
                <div>
                    <i className="fa fa-circle-o-notch m2spin" />
                    Loading Organizations...
                </div>
            );
        }
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <Message info={this.state.message} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <form onSubmit={this.onFormSubmit}>
                            <h2>{edit ? 'Edit' : 'Add New'} Consultant</h2>
                            <div className="form__field">
                                <label htmlFor="name">Name: </label>
                                <input type="text" name="name" value={this.state.name} onChange={this.onChangeName} disabled={edit ? true : false} />
                            </div>
                            <div className="form__field">
                                <label htmlFor="email">Email: </label>
                                <input type="text" name="email" value={this.state.email} onChange={this.onChangeEmail} disabled={edit ? true : false} />
                            </div>
                            <div className="form__buttons">
                                <Button type="submit" defaultText="Save" busyText="Inviting User" />
                                <Link to="" onClick={this.goBack}>
                                    Cancel
                                </Link>
                            </div>
                        </form>
                    </div>
                    <div className="col-6">
                        <div className="container">
                            <div className="column">
                                <div className="col-12">
                                    <h4>Consultant Type</h4>
                                </div>
                                <div className="col-12">
                                    <select value={this.state.permissions} onChange={this.changePermissions}>
                                        <option value="Administrator">Consultant</option>
                                        <option value="Restricted">Restricted Consultant</option>
                                        <option value="General Viewer">General Viewer</option>
                                    </select>
                                </div>
                            </div>
                            {this.state.permissions !== 'Administrator' ? (
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-12">
                                            <h4>Restrictions</h4>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <DynamicMultiSelect
                                                items={organizations}
                                                callBackFunction={this.checkItem.bind(this)}
                                                callBackAllFunction={this.checkAll.bind(this)}
                                                selected={selectedOrganizations}
                                                target="selectedOrganizations"
                                            />
                                        </div>
                                        <div className="col-6" />
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewTeamMemberPage;
